import { ADD_SERVICE, SET_SERVICES, UPDATE_SERVICE, REMOVE_SERVICE, ADD_SSO_REQUEST, } from '../constants/action-types';
export const initialState = {
    services: [],
    ssoRequest: null,
};
export const SsoReducer = (state = initialState, { type, payload } = {}) => {
    switch (type) {
        case SET_SERVICES:
            return { ...state, services: payload };
        case ADD_SERVICE:
            return { ...state, services: [...state.services, payload] };
        case REMOVE_SERVICE:
            return {
                ...state,
                services: [...state.services.filter((s) => s.id !== payload)],
            };
        case UPDATE_SERVICE:
            const index = state.services.findIndex((s) => s.id === payload.id);
            const updatedServices = [...state.services];
            updatedServices.splice(index, 1, payload);
            const newServices = index > -1 ? updatedServices : [...state.services, payload];
            return {
                ...state,
                services: newServices,
            };
        case ADD_SSO_REQUEST:
            return {
                ...state,
                ssoRequest: payload,
            };
        default:
            return state;
    }
};
export default SsoReducer;
